import { RouteConfig } from '../../../../routing/types'

export type PathArgs = any[]

const ROUTE: RouteConfig<PathArgs> = {
  name: 'membership-cancel',
  path: () => '/membership/cancel',
  type: 'private',
}

export default ROUTE
